import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/core/services/common.service';
import { HttpService } from 'src/app/core/services/http.service';
import { apiUrls } from 'src/app/core/services/urlList/apiUrls';

@Component({
  selector: 'app-sub-admin-password',
  templateUrl: './sub-admin-password.component.html',
  styleUrls: ['./sub-admin-password.component.scss']
})
export class SubAdminPasswordComponent implements OnInit, OnDestroy {
  parentData: any;
  id: any;
  adminInfo: any = null;
  password: string = '';
  confirmPassword: string = '';
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  submitted: boolean = false;
  errorMessage: string = '';
  loading: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public dialog: MatDialogRef<SubAdminPasswordComponent>,
    private http: HttpService,
    private api: apiUrls,
    private _commonService: CommonService
  ) { }

  ngOnInit(): void {
    if (this.parentData) {
      if (typeof this.parentData === 'string') {
        this.id = this.parentData;
      } else if (this.parentData && this.parentData._id) {
        this.id = this.parentData._id;
        this.adminInfo = this.parentData;
      } else {
        this.id = this.parentData;
      }
    }
  }

  get adminInitials(): string {
    if (!this.adminInfo) return 'SA';
    const first = (this.adminInfo.firstName || '').trim();
    const last = (this.adminInfo.lastName || '').trim();
    if (first && last) {
      return (first[0] + last[0]).toUpperCase();
    } else if (first) {
      return first.substring(0, 2).toUpperCase();
    }
    return 'SA';
  }

  get adminFullName(): string {
    if (!this.adminInfo) return 'Sub-Admin';
    const first = (this.adminInfo.firstName || '').trim();
    const last = (this.adminInfo.lastName || '').trim();
    return `${first} ${last}`.trim() || 'Sub-Admin';
  }

  get adminEmail(): string {
    return this.adminInfo?.email || '';
  }

  get strengthScore(): number {
    if (!this.password) return 0;
    let score = 0;
    if (this.password.length >= 8) score++;
    if (/[0-9]/.test(this.password)) score++;
    if (/[a-zA-Z]/.test(this.password)) score++;
    if (/[^a-zA-Z0-9]/.test(this.password)) score++;
    return score;
  }

  get strengthColor(): string {
    const score = this.strengthScore;
    if (score <= 1) return '#ef4444';
    if (score === 2) return '#f97316';
    if (score === 3) return '#eab308';
    return '#22c55e';
  }

  closeDialog() {
    this.dialog.close();
  }

  btn_updatePassword() {
    this.submitted = true;
    this.errorMessage = '';

    if (!this.password || !this.password.trim()) {
      this.errorMessage = 'Please enter a new password';
      return;
    }

    if (this.password.length < 8) {
      this.errorMessage = 'Password must be at least 8 characters long';
      return;
    }

    if (!this.confirmPassword || !this.confirmPassword.trim()) {
      this.errorMessage = 'Please confirm your password';
      return;
    }

    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'Passwords do not match';
      return;
    }

    this.loading = true;
    const payloadData = {
      password: this.password.trim()
    };

    this.http.put(this.api.subAdmin + '?id=' + this.id, payloadData).subscribe(
      (res: any) => {
        this.loading = false;
        if (res && (res['response']['status'] === 200 || res['response']['success'])) {
          this.dialog.close(true);
          this._commonService.onSuccessToaster(res['response']['message'] || 'Password updated successfully');
        } else {
          this.errorMessage = res?.response?.message || 'Failed to update password';
        }
      },
      (err: any) => {
        this.loading = false;
        this.errorMessage = err?.error?.message || 'Something went wrong while updating password';
      }
    );
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
